import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { useGetAllActivityLogs } from '../../services/react-query/activity_logs';
import { ActivityLogOwnerType } from '../../types/ActivityLog';
import { UserSettingsCollapseKeys } from '../../types/User';
import { Loading } from '../../uikit';
import AccordionSection from '../AccordionSection';
import { activityLogsStyles as styles } from './activityLogsStyles';
import ActivityLogTile from './ActivityLogTile';

interface IActivityLogsSectionProps {
  ownerUuid?: string;
  ownerType: ActivityLogOwnerType;
  collapseId: UserSettingsCollapseKeys;
}

const ActivityLogsSection: React.FC<IActivityLogsSectionProps> = ({ ownerUuid, ownerType, collapseId }) => {
  const { data: activityLogsData, isLoading: isGetAllActivityLogsLoading } = useGetAllActivityLogs({
    enabled: !!ownerUuid,
    params: {
      filters: {
        owner_uuid: ownerUuid,
        owner_type: ownerType,
      },
    },
  });

  if (!ownerUuid) return null;
  if (isGetAllActivityLogsLoading) return <Loading />;

  const activityLogs = activityLogsData?.data || [];

  return (
    <AccordionSection title="Activity Logs" collapseId={collapseId} id="activity-logs">
      <Box sx={styles.container}>
        {_.isEmpty(activityLogs) ? (
          <Typography sx={styles.noLogsText}>No activity yet.</Typography>
        ) : (
          _.map(activityLogs, (log) => <ActivityLogTile key={log.id} log={log} />)
        )}
      </Box>
    </AccordionSection>
  );
};

export default ActivityLogsSection;
